import { map, flow, assign, capitalize, isNil } from "lodash/fp";
import moment from "moment";
import constants from "../../core/constants";

class Controller {
  constructor(Events, $injector, $mdDialog) {
    "ngInject";

    this.Events = Events;
    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
  }
  $onInit() {
    const updateEvent = this.eventName;
    const originalSelected = this.selected;
    const removeSource = (item) => {
      item = item._source ? assign({ _id: item._id }, item._source) : item;
      item.name = item.name ? item.name : item.plates;

      return item;
    };
    const checkName = (item) => {
      if (!item.name) {
        item.name =
          item.route.name +
          " " +
          moment(item.date).format(constants.dateTimeFormat);
      }

      return item;
    };
    const confirm = this.$mdDialog
      .confirm()
      .title(`Are you sure you want to remove "${this.name}"?`)
      .textContent("If you chose to remove it you can add it again.")
      .ok("Remove")
      .cancel("Cancel");

    this.onAutoCompleteSearch = (text) => {
      const resource =
        this.resource === "Bus" ? capitalize(this.state) : this.resource;
      const request = this.$injector.get(resource).search(text, this.params);

      return request.$promise.then((list) =>
        flow([map(removeSource), map(checkName)])(list.hits)
      );
    };

    this.enableField = () => {
      this.selected.isDisabled = false;
    };

    this.onChange = (value) => {
      // Update the old _id with the new one
      if (this.onFieldChangeEvent && !value.isDisabled) {
        value._id = value.name._id;
        this.Events.emit(this.onFieldChangeEvent, {
          value,
          extraParams: this.extraParams,
        });
      }
    };

    this.onClear = () => {
      const id = this.selected._id;

      this.$mdDialog.show(confirm).then(
        () => {
          this.selected.name = null;
          const methodName = this.resourceMethodName;
          const options = {
            id,
            key: this.name,
            extraParams: this.extraParams,
            name: null,
            methodName,
          };

          if (this.extraParams) this.selected.extraParams = this.extraParams;
          this.Events.emit(updateEvent, options);
        },
        () => {}
      );
    };

    this.submitField = () => {
      const method = this.resourceMethod;
      const methodName = this.resourceMethodName;
      const options = {
        key: this.name || this.selected.key,
        method,
        methodName,
        index: this.index,
      };
      const result = assign(this.selected)(options, originalSelected);
      if (this.extraParams) result.extraParams = this.extraParams;
      delete result.value;
      if (updateEvent) {
        this.Events.emit(updateEvent, result);
      }
    };
  }

  isInputNil(input) {
    return isNil(input);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableAutocomplete/editableAutocomplete.controller.js